import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=43dcf2d6&scoped=true&"
import script from "./Tab.vue?vue&type=script&lang=js&"
export * from "./Tab.vue?vue&type=script&lang=js&"
import style0 from "./Tab.vue?vue&type=style&index=0&id=43dcf2d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dcf2d6",
  null
  
)

export default component.exports